export default __webpack_public_path__ + "static/media/36I-102816_-16012_0.4df1a276.jpg";